<template>
  <div class="asd-form">
    <label>{{ $t('common.name') }}</label>
    <input v-model="data.name" type="text" class="asd-input">
    <label>Vlastnosti</label>
    <Multiselect
      v-if="data.propertyType"
      v-model="data.propertyType"
      v-help.mouse="'Tímto výběrem se nedá určit pořadí vlastnosti v typu.|Pořadí vždy závisí na pořadí vlastností nastavene v editaci vlastností'"
      label="name"
      trackBy="key"
      :options="$store.getters.propertyTypes"
      :max="-1"
    ></Multiselect>
    <FormControls>
      <button v-if="resourceTypeId !== null"
              v-help.mouse="'Aktuální hodnoty uloží jako nový typ projektu.|Původní typ projektu nebude ovlivněn.'"
              class="asd-btn-confirm"
              @click="duplicate()"
      >
        Uložit jako nový
      </button>
      <button v-if="resourceTypeId !== null" class="asd-btn-confirm" @click="save()">
        Uložit
      </button>
      <button v-if="resourceTypeId === null" class="asd-btn-confirm" @click="create()">
        Vytvořit
      </button>
    </FormControls>
  </div>
</template>

<script>
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'
import FormControls from 'CORE/components/form/controls'
import _ from 'lodash'
import EventBus from 'CORE/bus'

export default {
    name: 'ResourceTypeForm',
    components: {
        Multiselect,
        FormControls,
    },
    props: {
        resourceTypeId: {
            type: String,
            required: false,
            default: _ => null,
        },
    },
    data: function() {
        return {
            data: {},
        }
    },
    computed: {
        resourceType() {
            return this.$store.getters.resourceTypeById(this.$route.params.id) || false
        },
    },
    mounted() {
        if (this.resourceTypeId === null) {
            this.data = {
                id: this.$uuid.v4(),
                name: '',
                propertyType: _.filter(this.$store.getters.propertyTypes, pt => _.get(pt, 'defaultResource', false)),
            }
            console.info(this.data)
        } else {
            this.data = this.$store.getters.resourceTypeById(this.resourceTypeId)
        }

        // integrity check
        if (!_.isArray(this.data.propertyType)) {
            this.$set(this.data, 'propertyType', _.filter(this.$store.getters.propertyTypes, pt => _.get(pt, 'defaultResource', false)))
        }

        console.assert(
            _.isString(_.get(this.data, 'id')),
            'Invalid ID after data creation (not existing ProjectType or invalid UUID creation)'
        )
    },
    methods: {
        async save() {
            try {
                await this.$store.dispatch('updateResourceType', this.data)
                await this.$store.dispatch('resourceTypesLoad')
                await this.$store.dispatch('propertyTypesLoad')
                EventBus.$emit('FLASH_OK', { message: 'Uloženo' })
                this.$emit('done')
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
            }
        },
        async create() {
            try {
                await this.$store.dispatch('createResourceType', this.data)
                await this.$store.dispatch('resourceTypesLoad')
                await this.$store.dispatch('propertyTypesLoad')
                EventBus.$emit('FLASH_OK', { message: 'Uloženo' })
                this.$emit('done')
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
            }
        },
        async duplicate() {
            this.data.id = this.$uuid.v4()
            this.data.name = `${this.data.name} - kopie`
            this.create()
        },
    },
}
</script>
